export const AVAILABILITY_REQUIREMENT_SCHEDULE_UPDATED = 'availability_requirement_schedules/UPDATED';
export const AVAILABILITY_REQUIREMENT_SCHEDULE_BATCH_UPDATE = 'availability_requirement_schedules/BATCH_UPDATE';

export const START = 'FETCH_AVAILABILITY_REQUIREMENT_SCHEDULE_START';
export const SUCCESS = 'FETCH_AVAILABILITY_REQUIREMENT_SCHEDULE_SUCCESS';
